// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3qqYl","content":"Consent_content__2KFda","footer":"Consent_footer__6Onc9"};